import { ERouteHttpVerb } from "@devowl-wp/api";
const routeLocationLicenseDelete = {
    path: "/license",
    method: ERouteHttpVerb.DELETE
};
export { routeLocationLicenseDelete };
